'use strict';

var Emitter = require('cjs-emitter'),
    geo = new Emitter();


function getLocationName ( coordinates, cb ) {
    var loc = null,
        language = core.environment.language,
        client = new XMLHttpRequest();

    client.open(
        'GET',
        'http://nominatim.openstreetmap.org/reverse?format=json&lat=' +
        coordinates.lat +
        '&zoom=18&addressdetails=1&lon=' +
        coordinates.lon +
        '&accept-language=' +
        language
    );

    client.onload = function () {
        if ( this.status === 200 ) {
            try {
                loc = JSON.parse(this.responseText);
            } catch ( error ) {
                debug.info(error, 'getLocality parse error');
            }
        }

        if ( loc !== null ) {
            geo.location = loc;
        }

        geo.emit('load', geo.location);
        cb(geo.location);
    };

    client.send(null);
}


module.exports = geo;

geo.location = {
    displayName: '',
    lat: 0,
    lon: 0,
    address: {
        city: '',
        state: '',
        country: ''
    }
};

geo.load = function ( location, cb ) {
    var client = new XMLHttpRequest(),
        locationName;

    if ( location.lat && location.lon ) {
        geo.location.lat = +location.lat;
        geo.location.lon = +location.lon;

        if ( location.name ) {
            location.displayName = location.name;
            geo.location = JSON.parse(JSON.stringify(location));
            locationName = geo.location.name.split(',');
            geo.location.address.city = locationName[0];
            geo.location.address.state = locationName[1];
            geo.location.address.country = locationName[2];
            geo.emit('load', geo.location);
        } else {
            getLocationName(geo.location);
        }

        return;
    }

    client.open('GET', 'http://weather.infomir.com.ua/getGeo.php');
    client.onload = function () {
        var coordinates = {
            data: {
                lon: 0,
                lat: 0
            }
        };

        if ( this.status === 200 ) {
            try {
                coordinates = JSON.parse(this.responseText);
            } catch ( error ) {
                debug.info(error);
            }

            geo.location.lat = +coordinates.data.lat;
            geo.location.lon = +coordinates.data.lon;

            getLocationName(geo.location, cb);
        } else {
            geo.emit('load', geo.location);
        }
    };
    client.send(null);
};


/**
 * Search location by its name.
 *
 * @param {Object} param - params for search engine
 * @param {string} param.language - language of search
 * @param {string} param.query - location for search
 * @param {Function} callback - method to invoke with a result of operation
 */
geo.search = function ( param, callback ) {
    var client = new XMLHttpRequest();

    client.open('GET', 'http://nominatim.openstreetmap.org/search?format=json&addressdetails=1&limit=5&accept-language=' + param.language + '&q=' + param.query);

    client.onload = function () {
        if ( this.status === 200 ) {
            try {
                callback(JSON.parse(this.responseText), false);
            } catch ( error ) {
                callback(null, 404);
            }
        } else {
            callback(null, this.status);
        }
    };
    client.onerror = function () {
        callback(null, this.status);
    };

    client.send(null);
};
